import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/shared/item_box'


function EmendasRJScreen() {
    return (
        <Fragment>
            <Head titulo="Emendas Parlamentares Estaduais" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1}>
                    <ItemBox
                    titulo={"Emendas Parlamentares Estaduais"}
                    texto={[<Fragment> A Prefeitura Municipal de Macuco não recebeu nenhuma emenda parlamentar proveniente de Deputados Estaduais do Rio de Janeiro nos anos de 2024 e 2025. Conforme o link abaixo (clique em "Veja Aqui") explicita, não há disponibilidade das emendas anteriores ao ano de 2024 no Portal da Transparência do Governo do Estado do Rio.
                        <br /><br /></Fragment>]}
                    link={"https://www.redeplan.planejamento.rj.gov.br/demaisprocessos/emendas.html"}
                />
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default EmendasRJScreen;